import { Object, Number, Optional, Array, String, Boolean, Static } from '@sinclair/typebox';

import { paxType } from '../../../..';

export const PassengerFieldsRequestQueryParams = Object({
  origin: String({
    examples: ['ARN'],
    description: 'Origin airport code',
  }),
  destination: String({
    examples: ['CPH'],
    description: 'Destination airport code',
  }),
  adults: Number({
    maximum: 9,
    description: 'Number of adult travelers',
    examples: [2],
  }),
  children: Optional(
    Number({
      description: 'Number of children',
      examples: [1],
    })
  ),
  infants: Optional(
    Number({
      description: 'Number of infants (must be equal or less to the number of adult travelers)',
      examples: [1],
    })
  ),
});

export type PassengerFieldsResponse = Static<typeof PassengerFieldsResponse>;
export const PassengerFieldsResponse = Array(
  Object({
    type: paxType,
    hasInfant: Optional(Boolean()),
    fields: Array(
      Object({
        name: String(),
        required: Boolean(),
        order: Number(),
      })
    ),
  })
);
export const FrequentFlyerValidatorResponseSchema = Object({
  accept: Boolean(),
  ffpTierLevel: Optional(String()),
  validationDetails: Object({
    replyFrom: String(),
    accountValid: Optional(Boolean()),
    numberValid: Optional(Boolean()),
    nameMatch: Optional(Boolean()),
  }),
});

export type FrequentFlyerValidatorResponse = Static<typeof FrequentFlyerValidatorResponseSchema>;
